import FeaturedShowItem from './FeaturedShowItem';

export default FeaturedShowItem;